import type { ExtractedInfo } from "../pages/api/chat";

/** sessionStorage key for the chat → introductory-call form handoff */
export const CHAT_INTAKE_STORAGE_KEY = "bb-chat-intake";

export const EMPTY_INFO: ExtractedInfo = {
  company: null,
  website: null,
  teamSize: null,
  fields: [],
  fieldsOther: null,
  offerings: [],
  offeringsOther: null,
  repeatable: null,
  tooling: [],
  toolingThirdParty: null,
  toolingOwnTool: null,
  goals: [],
  goalsOther: null,
  users: null,
  timeline: null,
  clientRequirements: null,
  toolIdea: null,
  callRecommended: false
};

/**
 * The server extracts from the last messages only, so a later extraction may
 * lack earlier facts: merge by unioning arrays and never clearing scalars.
 */
export const mergeInfo = (
  prev: ExtractedInfo,
  next: ExtractedInfo | null | undefined
): ExtractedInfo => {
  if (!next) return prev;
  const merged = { ...prev };
  (Object.keys(EMPTY_INFO) as Array<keyof ExtractedInfo>).forEach((key) => {
    const incoming = next[key];
    if (Array.isArray(EMPTY_INFO[key])) {
      const union = new Set([
        ...(prev[key] as string[]),
        ...(Array.isArray(incoming) ? incoming : [])
      ]);
      (merged[key] as string[]) = Array.from(union);
    } else if (typeof EMPTY_INFO[key] === "boolean") {
      // Once true, stays true — the CTA must not flicker away again
      (merged[key] as boolean) = (prev[key] as boolean) || incoming === true;
    } else if (typeof incoming === "string" && incoming) {
      (merged[key] as string) = incoming;
    }
  });
  return merged;
};
